import { Injectable } from '@angular/core';
import { ResourceEffect } from '@app/core/store/effects/resource.effect';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { State } from '@dwo/reducers';
import { Observable } from 'rxjs';
import { WorkCenterService } from '@app/core/services/work-center.service';
import {
  AddWorkCenter,
  LoadWorkCenters,
  LoadWorkCentersSuccess,
  UpdateWorkCenter,
  UpdateWorkCenterSuccess,
  WorkCenterActionTypes,
} from '@app/core/store/actions/work-center-action';

@Injectable()
export class WorkCenterEffect extends ResourceEffect {
  constructor(
    readonly actions$: Actions,
    readonly workCenterService: WorkCenterService,
    readonly store: Store<State>,
  ) {
    super(actions$, workCenterService, store);
  }

  loadWorkCenters$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<LoadWorkCenters>(WorkCenterActionTypes.LoadWorkCenters),
        this.fetchResource('loadWorkCenters', LoadWorkCentersSuccess, (action: LoadWorkCenters) => [action.siteId]),
      ),
  );

  addWorkCenter$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<AddWorkCenter>(WorkCenterActionTypes.AddWorkCenter),
        this.fetchResource('addWorkCenter', LoadWorkCenters, (action: AddWorkCenter) => [
          action.siteId,
          action.workCenter,
        ]),
      ),
  );

  updateWorkCenter$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<UpdateWorkCenter>(WorkCenterActionTypes.UpdateWorkCenter),
        this.fetchResource('updateWorkCenter', UpdateWorkCenterSuccess, (action: UpdateWorkCenter) => [
          action.siteId,
          action.workCenterId,
          action.workCenter,
        ]),
      ),
  );

  updateWorkCenterSuccess$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<UpdateWorkCenterSuccess>(WorkCenterActionTypes.UpdateWorkCenterSuccess),
        this.fetchResource('loadWorkCenters', LoadWorkCentersSuccess),
      ),
  );
}
